export default __webpack_public_path__ + "static/media/advantages__item-icon-2.8a5e8784.svg";